import {useGetUserFeatureAccessQuery} from 'generated/graphql'

export const useFeatureFlag = (featureName: string) => {
    const {data, loading, error} = useGetUserFeatureAccessQuery({
        variables: {featureName},
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
    })

    return {
        hasAccess: data?.userFeatureAccess ?? false,
        loading,
        error,
    }
}
